angular.module('callX').controller('LeadUsersListCtrl', ['$scope', 'UserService','LeadsService', 'DataService','$filter', 'toaster','$modal', '$location', '$anchorScroll','$state', function($scope, UserService,LeadsService, DataService,$filter, toaster, $modal, $location, $anchorScroll,$state) {

    $scope.leadUsersList = [];
    var currentUserData = UserService.getCurrentUserData();

//     $scope.maxSize = 5;
//     $scope.currentPage = 1;
//     $scope.itemsPerPage = 100;
//     $scope.pageChanged = function() {
// //        console.log("Current Page Num", $scope.currentPage);
//     };

    $scope.pageno = 0; 
    $scope.itemsPerPage = 50;

    $scope.itemsData = DataService.getAdvertiserSignupCodes();

    $scope.orderParam = 'created_at';
    $scope.reverse = true;
    $scope.order = function(orderParam) {
        $scope.reverse = ($scope.orderParam === orderParam) ? !$scope.reverse : false;
        $scope.orderParam = orderParam;
    };

    // $scope.fetchLeadUsersList = function(){
    //     $scope.tableContentLoading = true;
    //     var callbacks = {
    //         success: function(data) {
    //             if(data.data){
    //             $scope.leadUsersList = data.data;
    //             $scope.tableContentLoading = false;
    //             if(data.data.length == 0){
    //                 $scope.showNoDataDivTag = true;
    //             }
    //         }else{
    //            $scope.tableContentLoading = false;
    //            $scope.showNoDataDivTag = true;
    //         }
    //         if($state.current.name=='app.leads.lead-users-list'){
    //                 setTimeout(function(){
    //                     $scope.fetchLeadUsersList();
    //                 }, 300000);
    //             }
    //         },
    //         failure: function(data) {
    //             $scope.tableContentLoading = false;
    //         }
    //     };
    //     LeadsService.getLeadUsersList(currentUserData.id,callbacks);
    // };

    $scope.fetchLeadUsersList = function(){
        $scope.tableContentLoading = true;
        var callbacks = {
            success: function(data) {
                if(data.data){
                $scope.leadUsersList = data.data.content;
                $scope.totalItemsData = data.data.total_elements;
                $scope.itemsPerpageData = data.data.no_of_elements;
                $scope.tableContentLoading = false;
                if(data.data.no_of_elements == 0){
                    $scope.showNoDataDivTag = true;
                }
            }else{
               $scope.tableContentLoading = false;
               $scope.showNoDataDivTag = true;
               $scope.totalItemsData = 0;
            }
            if($state.current.name=='app.leads.lead-users-list'){
                    setTimeout(function(){
                        $scope.fetchLeadUsersList();
                    }, 300000);
                }
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        LeadsService.getLeadUsersList($scope.pageno,$scope.itemsPerPage,currentUserData.id,callbacks);
    };

    $scope.getData = function(pageno){
        $scope.pageno = pageno-1;
        $scope.tableContentLoading = true;
        var callbacks = {
            success: function(data) {
                $scope.leadUsersList = data.data.content;
                $scope.tableContentLoading = false;
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        LeadsService.getLeadUsersListData(pageno-1,$scope.itemsPerPage,currentUserData.id,callbacks);
    };

    $scope.callValue = function(numPerPage)
    {
        $scope.itemsPerPage = numPerPage;
        $scope.fetchLeadUsersList();
    };


    $scope.getExportCSVDownload = function(){
        $scope.showSuccessAlert = true;
        var callbacks = {
            success: function(data) {
                $scope.exportData = data.fileURL;
                $scope.showSuccessAlert = false;
                $scope.exportCSVModal();
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
                toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
            }
        };
        LeadsService.getPromoGranularDataExportCSV($scope.pageno,$scope.itemsPerPage,currentUserData.id,callbacks);
    };

    $scope.exportCSVModal  = function(){
            $scope.openLeadCopyConfirmationModal();
    };
    $scope.openLeadCopyConfirmationModal = function () {
        var exportCSVURL = $scope.exportData;
        var modalInstance = $modal.open({
            templateUrl: 'tpl/blocks/lead_export_csv.html',
            controller: 'LeadExportCSVCtrl',
            size: 'lg',
            resolve: {
                object: function () {
                    return exportCSVURL;
                }
            }
        });
    };

//    console.log("currentUserData",currentUserData);
    if(currentUserData.id!=undefined){
        $scope.fetchLeadUsersList();
    }

    $scope.$on('currentUserUpdate', function(event, userData) {
        currentUserData = userData;
        $scope.fetchLeadUsersList();
    });


    $scope.leadHistoryCall = function (id){
        var callbacks = {
            success: function(data) {
               $scope.leadHistoryData = data.data;
               $scope.openCopyConfirmationModal();

            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        LeadsService.getLeadHistory(id,callbacks);
    };
    
    $scope.openCopyConfirmationModal = function () {
        //var leadHistory = [];
        var leadHistory = $scope.leadHistoryData;
        var modalInstance = $modal.open({
            templateUrl: 'tpl/blocks/lead_history.html',
            controller: 'LeadHistoryCtrl',
            size: 'lg',
            resolve: {
                object: function () {
                    return leadHistory;
                }
            }
        });

        modalInstance.result.then(function (selectedItem) {
          $scope.selected = selectedItem;
      }, function () {
          $log.info('Modal dismissed at: ' + new Date());
      });
    };
    
}]);